import { render, staticRenderFns } from "./permissionInfo.vue?vue&type=template&id=5bdc3fc4&"
import script from "./permissionInfo.vue?vue&type=script&lang=js&"
export * from "./permissionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports